import { render, staticRenderFns } from "./Experiment.vue?vue&type=template&id=09df42ba&lang=pug"
import script from "./Experiment.vue?vue&type=script&lang=ts"
export * from "./Experiment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Block: require('/app/components/generic/Block.vue').default})
